var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunderBrick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34375 5L12.6875 0.4375C12.8542 0.291667 13.0521 0.21875 13.2812 0.21875C13.5729 0.239583 13.8125 0.354167 14 0.5625C14.1667 0.791667 14.2083 1.0625 14.125 1.375L12.4688 7.21875H15.125C15.4375 7.21875 15.6979 7.32292 15.9062 7.53125C16.1146 7.73958 16.2188 8 16.2188 8.3125C16.2188 8.64583 16.0938 8.92708 15.8438 9.15625L14.2812 10.4688L19.9375 14.875C20.2708 15.1875 20.3125 15.5417 20.0625 15.9375C19.75 16.2708 19.3958 16.3125 19 16.0625L0.5 1.5625C0.166667 1.25 0.125 0.895833 0.375 0.5C0.6875 0.166667 1.04167 0.125 1.4375 0.375L7.34375 5ZM8.53125 5.96875L10.7812 7.6875L12.1562 2.875L8.53125 5.96875ZM12.0625 8.71875L13.0938 9.5L14.0312 8.71875H12.0625ZM10.75 11.5L11.9375 12.4375L7.75 16C7.58333 16.1458 7.38542 16.2188 7.15625 16.2188C6.86458 16.1979 6.625 16.0833 6.4375 15.875C6.27083 15.6458 6.22917 15.375 6.3125 15.0625L7.9375 9.3125L9.21875 10.2812L8.28125 13.5938L10.75 11.5ZM5.03125 7L7.84375 9.21875H5.28125C4.96875 9.21875 4.71875 9.11458 4.53125 8.90625C4.32292 8.71875 4.21875 8.46875 4.21875 8.15625C4.21875 7.84375 4.34375 7.58333 4.59375 7.375L5.03125 7Z",
    fill: "#7E8299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderBrick);
export default __webpack_public_path__ + "static/media/thunder-brick.18779b7d3c70f28bc97faa261d8f799e.svg";
export { ForwardRef as ReactComponent };